import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Radio, Space, Spin } from 'antd';
import { isMobile } from 'react-device-detect';
import { setCustomerPrimaryPhone, fetchCustomerPhones } from '@/redux/actions/customerActions';

const { confirm } = Modal;

class CustomerPrimaryPhoneModal extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            phones: [],
            selectedPhoneId: null,
        };
    }

    componentDidMount() {
        const { visible, customerId } = this.props;
        if (visible && customerId) {
            this.loadPhones();
        }
    }

    componentDidUpdate(prevProps) {
        const { visible, customerId } = this.props;

        // mở modal hoặc đổi customerId khi đang mở -> fetch lại
        const justOpened = !prevProps.visible && visible;
        const changedCustomer = prevProps.customerId !== customerId;

        if (visible && customerId && (justOpened || changedCustomer)) {
            this.loadPhones();
        }

        // đóng modal -> reset (để lần sau mở lại sạch)
        if (prevProps.visible && !visible) {
            this.setState({ selectedPhoneId: null, phones: [], loading: false });
        }
    }

    loadPhones = async () => {
        const { customerId } = this.props;
        if (!customerId) return;

        this.setState({ loading: true });

        try {
            // action resolve ra array phones
            const phones = await this.props.fetchCustomerPhones(customerId);

            const primaryId =
                phones?.find(p => Number(p.is_primary) === 1)?.id ?? null;

            this.setState({
                phones: phones || [],
                selectedPhoneId: primaryId,
                loading: false,
            });
        } catch (e) {
            this.setState({ loading: false });
        }
    };

    onClose = () => {
        this.props.onCancel();
    };

    handleChange = (e) => {
        const phone_id = e.target.value;
        const selectedPhone = this.state.phones.find(p => p.id === phone_id);

        confirm({
            title: 'Bạn có chắc muốn đặt số này là số chính?',
            content: selectedPhone?.phone,
            okText: 'Đồng ý',
            cancelText: 'Hủy',
            onOk: async () => {
                try {
                    this.setState({ loading: true });

                    await this.props.setCustomerPrimaryPhone({ phone_id });

                    // refresh list trong modal
                    await this.loadPhones();

                } catch (err) {
                    this.setState({ loading: false });
                }
            },
        });
    };

    render() {
        const { visible } = this.props;
        const { phones, selectedPhoneId, loading } = this.state;

        const currentPrimaryId =
            selectedPhoneId ?? phones.find(p => Number(p.is_primary) === 1)?.id;

        return (
            <Modal
                visible={visible}
                title="Chọn số điện thoại chính"
                onCancel={this.onClose}
                footer={null}
                maskClosable={false}
                width={isMobile ? '100%' : 420}
                destroyOnClose
            >
                <Spin spinning={loading}>
                    {phones && phones.length > 0 ? (
                        <Radio.Group
                            onChange={this.handleChange}
                            value={currentPrimaryId}
                            style={{ width: '100%' }}
                        >
                            <Space direction="vertical" style={{ width: '100%' }}>
                                {phones.map((item) => (
                                    <Radio key={item.id} value={item.id}>
                                        {item.phone}{' '}
                                        {Number(item.is_primary) === 1 ? '(Số chính)' : ''}
                                    </Radio>
                                ))}
                            </Space>
                        </Radio.Group>
                    ) : (
                        <p>Không có số điện thoại nào.</p>
                    )}
                </Spin>
            </Modal>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCustomerPrimaryPhone: (data) => dispatch(setCustomerPrimaryPhone(data)),
        fetchCustomerPhones: (id) => dispatch(fetchCustomerPhones(id)),
    };
}

export default connect(null, mapDispatchToProps)(CustomerPrimaryPhoneModal);